import { assert } from 'console';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import back from './back2.svg';
import * as style from './Switch.module.less';
import { Flex } from '../UI/Flex/Flex';
import { Button } from 'react-bootstrap';
import { useStoreUI } from '@assets/model/Store';

interface ISwitch {
    children: React.ReactNode;
    activeView: number;
    backButtonOffset: number;
    onBack?: () => void;
}
export const Switch = observer((props: ISwitch) => {
    const children = React.Children.toArray(props.children);
    assert(children.length > props.activeView, 'Active view is out of range');
    const uiStore = useStoreUI();
    useEffect(() => {
        if (uiStore.isKeyEscapeDown && props.activeView > 0) {
            props.onBack();
        }
    }, [uiStore.isKeyEscapeDown]);
    const childrenView = children.map((child, index) => {
        return (
            <div
                key={index}
                className={style.switchView}
                style={{
                    opacity: index === props.activeView ? 1 : 0,
                    pointerEvents: index === props.activeView ? 'auto' : 'none',
                    zIndex: index === props.activeView ? 10000 : 0
                }}
            >
                {child}
            </div>
        );
    });
    return (
        <>
            <Flex fillCell={true} style={{ position: 'relative' }}>
                <div
                    className={style.backButton}
                    onClick={props.onBack}
                    style={{
                        opacity: props.activeView === 0 ? 0 : 1,
                        right: props.backButtonOffset
                    }}
                >
                    <Button variant="light">
                        <img src={back} />
                        Back
                    </Button>
                </div>
                {childrenView}
            </Flex>
        </>
    );
});
